import { useQuery } from "react-query";
import { getMenuItems_api } from "../services/menuItems";

export const useGetMenuItems = (body) =>
	useQuery(["getMenuItems", body], () => getMenuItems_api(body));
